import { Stack } from "@mui/material";
import React, { useState } from "react";
import MobileFirstSection from "./MobileFirstSection";
import CarouselSection from "../Horizontal Accordion/Carousel/CarouselSection";
import Carousel from "../Horizontal Accordion/Carousel/Carousel";
import MobileSectionCarousel from "./MobileSectionCarousel";

const MobileHeroSection = () => {
  const [selectedIndex, setSelectedIndex] = useState(0); // State to manage the selected index

  const handleIndexChange = (index) => {
    setSelectedIndex(index); // Update the selected index
  };
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f2f2f2",
      }}
    >
      <Stack
        sx={{
          // border: "1px solid red",
          width: "100%",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          // borderRadius: "8px",
          backgroundColor: "rgb(233 240 244)",
          paddingLeft: "4px",
          marginTop: "0px",
          height: "40px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "12px",
        }}
      >
        <MobileFirstSection
          selectedIndex={selectedIndex}
          onIndexChange={handleIndexChange} // Pass the handler to update the index
        />
      </Stack>
      <Stack sx={{ width: "100%" }}>
        <MobileSectionCarousel
          selectedIndex={selectedIndex}
          onIndexChange={handleIndexChange} // Pass the handler to update the index
        />
      </Stack>
    </Stack>
  );
};

export default MobileHeroSection;
